export const FormKey = Object.freeze({
  INVALID: '$invalid',
  DIRTY: '$dirty',
  ORIGINAL: '$originalValue',
  ERROR: '$error',
  CLEAN: '$clean',
  RESET: '$reset',
  TOUCH: '$touch',
})
